<div class="tab-content">
  <div id="districtapprovals" role="tabpanel" class="tab-pane active collapse show">
    <spinner [id]="'approvecomp'" [show]='activeSpinner'></spinner>
    <div class="row">
      <div class="col-md-12">
        <div class="tab" role="tabpanel">
          <ul class="nav nav-tabs" role="tablist" style="margin-top: 0px;">
            <li role="presentation" class="nav-item pointer" style="width: 50%;"><a style="margin: 0px;"
                class="nav-link" [ngClass]="{'active': activesidetab == 'usermanagement'}"
                (click)="navtabclick('usermanagement')" name="usermanagement"
                aria-selected="true">{{'componentPages.usermanagement' | translate}}</a></li>
            <li role="presentation" class="nav-item pointer"><a style="margin: 0px;" class="nav-link"
                [ngClass]="{'active': activesidetab == 'logs'}" (click)="navtabclick('logs')" name="logs"
                aria-selected="false">{{'userManagement.Logs' | translate}}</a></li>

          </ul>

          <div class="tab-content p-4" *ngIf="activesidetab == 'usermanagement'">
            <div class="col-md-12">
              <div role="tabpanel" class="tab-pane fade active show" id="pending">
                <div class="d-flex justify-content-between">
                  <h3 class="mt-3 ml-3">{{'userManagement.users' | translate}}</h3>
                  <div class="d-flex form-row m-3">
                    <form class="infline-form mr-2">
                      <input type="text" name="searchString" (keyup)="searchBarFilter($event)" class="form-control"
                        placeholder="{{'userManagement.search here'| translate}}">
                    </form>
                    <button type="button" permissions="ADD_USER_BTN" class="btn btn-info"
                      (click)="addUser()">{{'userManagement.adduser' | translate}}+</button>
                    <button type="button" class="btn btn-info" (click)="downloadAsPDF('userslist')"
                      *ngIf="userComponentList" style="margin-left: 12px;">{{ 'listofdgc.print' | translate }}</button>
                  </div>
                </div>

                <div class="table-responsive mt-2">
                  <table class="table table-sm" id="content">
                    <spinner [id]="'approveinfo'" [show]='activeSpinner'></spinner>
                    <thead class="thead-light">
                      <tr>
                        <th>{{'submitdata.slno' | translate}}</th>
                        <th>{{'header.userName' | translate}}</th>
                        <th>{{'submitdata.name' | translate}}</th>
                        <th>{{'userManagement.role' | translate}}</th>
                        <th>{{'submitdata.emailid' | translate}}</th>
                        <th>{{'submitdata.mobile' | translate}}</th>
                        <th>{{'header.state' | translate }}</th>
                        <!-- <th>Password</th> -->
                        <!-- <td *ngIf ="currentLoggedInUserInfo['role'] == 'GEC_STATE_ADMIN'">{{isBasin ? "Basin" : "District"}}</td> -->
                        <!-- <td>Designation</td>
                            <td>User Location</td>
                            <td>Status</td> -->
                        <th>{{'userManagement.actions' | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let user of userComponentList; let i=index">
                        <td class="color-td text-dark">{{ i+1 }}</td>
                        <td style="text-align : left;" class="color-td text-dark">{{ user.userName }}</td>
                        <td style="text-align : left;" class="color-td text-dark">{{ user.name}}</td>
                        <td style="text-align : left;" class="color-td text-dark">{{user.role}}</td>
                        <td style="text-align : left;" class="color-td text-dark">{{user.email}}</td>
                        <td class="color-td text-dark">{{ user.mobileNo }}</td>
                        <td style="text-align : left;" class="color-td text-dark">{{user.userDetailsJson['stateName']}}</td>
                        <!-- <td style="text-align : left;" class="color-td text-dark">pswd text</td> -->
                        <td>
                          <div class="d-flex justify-content-center">
                            <div class="text-info mx-2 pointer" (click)="viewPassword(user)" title="View Password"><i class="fas fa-eye"></i>
                            </div>
                            <div *ngIf="user.passwordVisible" class="password-popup">
                              {{ user.password }}
                            </div>
                            <div class="text-warning mx-2 pointer" (click)="editUser(user)" title="Edit User"><i class="fas fa-edit"></i>
                            </div>
                            <div class="text-danger mx-2 pointer" (click)="openChangePasswrdModal(user)" title="Change Password"><i class="fas fa-key"></i>
                            </div>
                            <div class="text-danger mx-2 pointer" (click)="deleteUser(user)" title="Delete User">
                              <i class="fas fa-trash"></i></div>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="(users | filter: searchString).length == 0">
                        <td colspan="9" class="text-center" style="color:#fff">{{'userManagement.nouser' | translate}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-content" *ngIf="activesidetab == 'logs'">

            <h3>{{'userManagement.Log Files Section' | translate}}</h3>
            <div class="row">
              <div class="col-12 col-xl col-md-6">
                <label>{{'header.assesmentyear' | translate}}<span class="text-star">*</span></label>
                <select [(ngModel)]="assessmentYear" class="form-control custom-selectbox">
                  <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
                </select>
              </div>
              <div class="col-12 col-xl col-md-6">
                <label>{{'dataSubs.selectmode' | translate}}<span class="required-field">*</span></label>
                <select [(ngModel)]="selectedMode" class="form-control custom-selectbox w-100"
                 (change)="showdropdown(selectedMode)">
                  <option value="undefined">{{'dataSubs.selectmode' | translate}}</option>
                  <option *ngFor="let mode of modeList" [value]="mode.key">{{'dataSubs.' + mode.value | translate}}</option>
                </select>
              </div>
              <div class="col-12 col-xl col-md-6" *ngIf="showDrop == 'monthwise'">
                <div>
                  <label>{{'dataSubs.month' | translate }}&nbsp;<span class="text-star">*</span></label>
                  <select [(ngModel)]="monthlist['montharray']" (change)="selectOption($event.target.value)"
                    class="form-control custom-selectbox">
                    <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate }}</option>
                    <option *ngFor="let month of monthsList" [value]="month.key">
                      {{'monthmaps.' + month['value'] | translate}}</option>
                  </select>
                </div>
              </div>

              <div class="col-12 col-xl col-md-6" *ngIf="showDrop == 'statewise'">
                <!-- <div class="form-group my-2"> -->
                  <label>{{ 'header.state' | translate }}<span class="required-field">*</span></label>
                  <select [(ngModel)]="selectedstate" class="form-control custom-selectbox w-100">
                    <option value="undefined" [disabled]="true">{{ 'tabledataforstates.selectstate' | translate }} </option>
                    <option *ngFor="let state of statelists" value="{{state['uuid']}}">{{ 'tabledataforstates.' + state['name'] | translate}}</option>
                  </select>
                <!-- </div> -->
              </div>
              <div class="col d-flex justify-content-start align-items-end">
                <button class="btn btn-info btn-sm mr-2" (click)="getLogs()" name="submit"
                  type="button">{{'dataSubs.VIEW' | translate}}</button>
              </div>
              <div class="col d-flex justify-content-start align-items-end" *ngIf="logdata">
                <button type="button" class="btn btn-info" (click)="downloadAsPDF('logs')">{{ 'listofdgc.print' | translate }}</button>
              </div>
            </div>

            <div>
              <table class="table table-bordered mt-2" id="content">
                <thead style="text-align: center;">
                  <tr>
                    <!-- ngfor in tr -->
                    <th>{{'userManagement.User' | translate}}</th>
                    <th>{{'header.state' | translate}}</th>
                    <th>{{'header.district' | translate}}</th>
                    <th>{{'userManagement.IP Address' | translate}}</th>
                    <th>{{'userManagement.Login Date and Time' | translate}}</th>
                    <th>{{'userManagement.Login Status' | translate}}</th>
                    <th>{{'userManagement.Logout Time' | translate}}</th>
                    <th>{{'userManagement.Access Date' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let log of logdata">
                    <td style="text-align:left;">{{log['userName']}}</td>
                    <td>{{log['state']}}</td>
                    <td>{{log['district']}}</td>
                    <td>{{log['ipAddress']}}</td>
                    <td>{{formatTmStmp(log['loginTime'])}}</td>
                    <td>{{log['loginStatus']}}</td>
                    <td>{{formatTmStmp(log['logoutTime'])}}</td>
                    <td>{{log['accessDate']}}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>

<ng-template #resetPassword>
  <div>
    <div class="modal-header border-0 m-0">
      <h2 style="text-align:center">{{'header.Change Password' | translate}}</h2>
      <button type="button" (click)="CloseModal()" class="close pointer text-black">
        <span class="text-dark">x</span>
      </button>
    </div>
    <div class="modal-body p-0">
      <div class="form-group">
        <label>{{'userManagement.Username' | translate}}</label>
        <input type="text" [(ngModel)]="username" disabled class="form-control">
      </div>
      <div class="form-group">
        <label>{{'userManagement.New Password' | translate}}</label>
        <input type="password" class="form-control" [(ngModel)]="newPsswrd" (input)="pswdValidate(newPsswrd)">
        <span style="color:red" [hidden]="!showerrorpwd">Note: Password must contain a capital letter,a lowercase letter,a number,a special character and minimum 8 characters</span>
      </div>
      <div class="form-group">
        <label>{{'userManagement.Confirm Password' | translate}}</label>
        <input type="password" class="form-control" [(ngModel)]="cnfPsswrd">
      </div>
      <div class="d-flex justify-content-center">
        <button class="btn btn-info btn-lg" (click)="changePassword()">{{'submitdata.save' | translate}}</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewpassword>
  <div class="p-4 bg-white rounded shadow-lg">
    <div class="modal-header p-0 d-flex justify-content-end border-0">
      <button type="button" (click)="CloseModal()" class="btn btn-sm btn-light border">
        <span class="fw-bold text-dark">×</span>
      </button>
    </div>

    <div class="text-center mt-3 mb-2">
      <h5 class="text-primary fw-semibold"> Password</h5>
      <p class="mt-2 px-2 py-1 bg-light rounded text-dark d-inline-block">
        {{ userPassword }}
      </p>
    </div>
  </div>
</ng-template>